import React from "react";
import { useNavigate } from "react-router-dom";

const WhatsappWalletFailed = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/payment/payment-options"); // navigate to home
  };

  return (
    <div className="min-h-screen flex justify-center items-center bg-red-50">
      <div className="bg-white p-8 rounded-xl shadow-lg text-center max-w-md">
        <h1 className="text-3xl font-bold text-red-600 mb-4">Payment Failed</h1>
        <p className="text-gray-700 mb-6">
          Something went wrong with your payment. Please try again.
        </p>
        <button
          onClick={goHome}
          className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default WhatsappWalletFailed;
